/**
 * Is this a connection worth spending megabytes on?
 *
 * <p>Extracted from {@code PhotoQueue}, which asked the same question for inspection photos and
 * now delegates here, so the two callers cannot drift apart. The public apply form needs it
 * without dragging in the photo outbox and its IndexedDB store — the students it is for are the
 * ones least able to afford the download.</p>
 *
 * <p><b>Advisory only.</b> Nothing here refuses an upload; it chooses how early to warn.</p>
 */

/**
 * ⚠️ {@code effectiveType} and {@code downlink} describe the <b>downlink</b>. Upload is typically
 * several times slower and asymmetric, so anything derived from them flatters the connection.
 * That is why callers use this as a two-way hint rather than computing a number from it.
 */
export function isGoodConnection(): boolean {
    if (!navigator.onLine) return false;
    const conn = (navigator as any).connection;
    // Absent on Safari and Firefox. Assume good and carry on — the same behaviour as before this
    // existed, and better than warning every iPhone user about a connection we cannot see.
    if (!conn) return true;
    // An explicit setting from the user's own device. Honoured outright, not weighed.
    if (conn.saveData) return false;
    return !['slow-2g', '2g'].includes(conn.effectiveType);
}
